import { SimpleGrid } from '@wegroup/design-system';
import React from 'react';
import { CalculationSpec } from '../../../../../../../../../types/Quotes';
import OfferParameterSpec from './OfferParameterSpec';

interface Props {
  calculationSpecs: CalculationSpec[];
}

const OfferParametersGrid: React.FC<Props> = ({ calculationSpecs }) => {
  return (
    <SimpleGrid columns={2} gap="3">
      {calculationSpecs.map((calcSpec, index) => (
        <OfferParameterSpec key={index} calcSpec={calcSpec} />
      ))}
    </SimpleGrid>
  );
};

export default OfferParametersGrid;
